import { isValidObject } from '../../Validity';
import { goalDescription, highlightDescription, penaltyDescription, powerplayDescription } from './IceHockeyStatDescription';

// ---------------------------------------------------------------------------------------------------------
// Goals
// ---------------------------------------------------------------------------------------------------------

export const ourGoalsDescription = (goals: any[]) => {
    if (isValidObject(goals)) {
        return goals.map((goal: any) => {
            if (goal.team === 'our') {
                return goalDescription(goal);
            }
            return null;
        });
    }
    return [];
};

export const opponentGoalsDescription = (goals: any[]) => {
    if (isValidObject(goals)) {
        return goals.map((goal: any) => {
            if (goal.team === 'opponent') {
                return goalDescription(goal);
            }
            return null;
        });
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Highlights
// ---------------------------------------------------------------------------------------------------------

export const ourShotsDescription = (highlightsPerPeriod: any[]) => {
    if (isValidObject(highlightsPerPeriod)) {
        return highlightsPerPeriod.map((highlight: any) => {
            if (highlight.team === 'our' && highlight.type === 'shots') {
                return highlightDescription(highlight);
            }
            return null;
        });
    }
    return [];
};

export const ourBlocksDescription = (highlights: any[]) => {
    if (isValidObject(highlights)) {
        return highlights.map((highlight: any) => {
            if (highlight.team === 'our' && highlight.type === 'blocks') {
                return highlightDescription(highlight);
            }
            return null;
        });
    }
    return [];
};

export const ourSavesDescription = (highlights: any[]) => {
    if (isValidObject(highlights)) {
        return highlights.map((highlight: any) => {
            if (highlight.team === 'our' && highlight.type === 'saves') {
                return highlightDescription(highlight);
            }
            return null;
        });
    }
    return [];
};

export const opponentShotsDescription = (highlightsPerPeriod: any[]) => {
    if (isValidObject(highlightsPerPeriod)) {
        return highlightsPerPeriod.map((highlight: any) => {
            if (highlight.team === 'opponent' && highlight.type === 'shots') {
                return highlightDescription(highlight);
            }
            return null;
        });
    }
    return [];
};

export const opponentBlocksDescription = (highlightsPerPeriod: any[]) => {
    if (isValidObject(highlightsPerPeriod)) {
        return highlightsPerPeriod.map((highlight: any) => {
            if (highlight.team === 'opponent' && highlight.type === 'blocks') {
                return highlightDescription(highlight);
            }
            return null;
        });
    }
    return [];
};

export const opponentSavesDescription = (highlightsPerPeriod: any[]) => {
    if (isValidObject(highlightsPerPeriod)) {
        return highlightsPerPeriod.map((highlight: any) => {
            if (highlight.team === 'opponent' && highlight.type === 'saves') {
                return highlightDescription(highlight);
            }
            return null;
        });
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Penalties
// ---------------------------------------------------------------------------------------------------------

export const ourPenaltiesDescription = (penalties: any[]) => {
    if (isValidObject(penalties)) {
        return penalties.map((penalty: any) => {
            if (penalty.team === 'our') {
                return penaltyDescription(penalty);
            }
            return null;
        });
    }
    return [];
};

export const opponentPenaltiesDescription = (penalties: any[]) => {
    if (isValidObject(penalties)) {
        return penalties.map((penalty: any) => {
            if (penalty.team === 'opponent') {
                return penaltyDescription(penalty);
            }
            return null;
        });
    }
    return [];
};

// ---------------------------------------------------------------------------------------------------------
// Powerplays
// ---------------------------------------------------------------------------------------------------------

export const ourPowerplaysDescription = (powerplays: any[]) => {
    if (isValidObject(powerplays)) {
        return powerplays.map((powerplay: any) => {
            if (powerplay.team === 'our') {
                return powerplayDescription(powerplay);
            }
            return null;
        });
    }
    return [];
};

export const opponentPowerplaysDescription = (powerplays: any[]) => {
    if (isValidObject(powerplays)) {
        return powerplays.map((powerplay: any) => {
            if (powerplay.team === 'opponent') {
                return powerplayDescription(powerplay);
            }
            return null;
        });
    }
    return [];
};
